<template>
	<el-row class="points-show">
		<el-col :span="24">
			<el-col :span="10">话术管理</el-col>
			<el-col :span="10" :offset="4">
				<span style="color:#409eff;font-size:13px">*修改完毕之后记得点击一下同步按钮哦~，否则有可能不生效哦<span class="el-icon-right" />
				</span>
				<el-button type="primary" size="mini" style="margin-left: 30px;" @click="SynchronizeData" plain>
					同步<i class="el-icon-refresh "></i>
				</el-button>
			</el-col>


		</el-col>
		<el-divider></el-divider>
		<el-row :gutter="20">
			<el-col :span="5">
				<div class="search-view">
					<div>话术类型：</div>
					<el-select placeholder="请选择" clearable size="mini" v-model="searchform.scatteredDic">
						<el-option v-for="item in labeloptions" :key="item.dicId" :label="item.dicDesc"
							:value="item.dicId" />
					</el-select>
				</div>
			</el-col>
			<el-col :span="5">
				<div class="search-view">
					<div>关键字：</div>
					<el-input size="mini" v-model="searchform.keywords" placeholder="请输入关键字" clearable />
				</div>
			</el-col>
			<el-col :span="5">
				<!-- <el-date-picker
					size="mini"
					style="margin-left:10px;"
					format="yyyy-MM-dd HH:mm:ss"
					value-format="yyyy-MM-dd HH:mm:ss"
					v-model="searchform.datevalue"
					type="datetimerange"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					align="right"
				></el-date-picker> -->
				<div>审核状态：</div>
				<el-select placeholder="请选择" clearable size="mini" v-model="searchform.showStatus">
					<el-option v-for="(item,index) in reviewStatus" :key="index" :label="item.title"
						:value="item.type" />
				</el-select>
			</el-col>
			<el-col :span="4">
				<el-button plain size="mini" type="primary" style="margin-left: 10px;" @click="search">搜索</el-button>
				<el-button plain style="margin-left: 30px;" size="mini" type="primary" @click="Empty">清空</el-button>
				<el-upload :show-file-list="false" style="margin-left: 10px;" class="upload-demo"
					:on-success="uploadSuccess" :on-error="uploadError" :action="uploadUrl" :file-list="fileList"
					name="files" multiple :limit="1">
					<el-button size="mini" style="margin-left: 20px;" type="primary" plain>
						导入excel
					</el-button>
				</el-upload>
				<el-button size="mini" style="margin-left: 20px;" type="primary" @click="WordsAdd(1)" plain>
					添加话术
				</el-button>
				<el-button size="mini" style="margin-left: 20px;" type="text" @click="downloadExcel" plain>
					下载摸版
				</el-button>
			</el-col>
		</el-row>
		<!-- table -->
		<el-col :span="24">
			<el-table :data="tableData" :height="tableHeight">
				<el-table-column type="index" width="50"></el-table-column>
				<el-table-column prop="problem" label="问题" />
				<el-table-column prop="skills" label="回答话术">
					<template slot-scope="scope">
						<el-tooltip v-if="scope.row.defaultAnswer!=''" class="item" effect="dark" content="点击查看更多答案"
							placement="top">
							<div style="cursor: pointer;" @click="loadMoreAnswer(scope.row,1)">
								<span style="color: #409EFF;">{{scope.row.defaultAnswer}}</span>
							</div>
						</el-tooltip>
						<el-button v-else size="mini" @click="loadMoreAnswer(scope.row,2)">点击添加</el-button>
					</template>
				</el-table-column>
				<el-table-column prop="dicDesc" label="话术类型" />
				<el-table-column prop="status" label="审核状态">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.status==0" type="success" size="mini">显示</el-tag>
						<el-tag v-if="scope.row.status==1" type="warning" size="mini">隐藏</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="上传时间">
					<template slot-scope="scope">
						<span>{{scope.row.createTime|formatDate}}</span>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="230px">
					<template slot-scope="scope">
						<el-button plain size="mini" type="info" @click="WordsAdd(2,scope.row)">编辑</el-button>
						<el-button plain type="danger" size="mini" @click="delScattered(scope.row.id,1)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</el-col>
		<!-- 分页小组件 -->
		<el-col :span="24">
			<el-pagination small layout="total, sizes, prev, pager, next, jumper" :page-size="pageSize" :total="total"
				:current-page.sync="pageNum" @current-change="handleCurrentChange" @size-change="handleSizeChange"
				:page-sizes="pageSizes">
			</el-pagination>
		</el-col>
		<!-- 添加/编辑 -->
		<el-dialog :title="isadd==1?'添加话术':'修改话术'" :visible.sync="dialogVisible" :before-close="closeUpdate"
			width="25%">
			<!-- 新增话术的 -->
			<template v-if="isadd==1">
				<el-form :model="addform" label-position="right" label-width="120px">
					<el-form-item label="问题:">
						<el-input size="mini" :rows="5" placeholder="请输入内容" v-model="addform.problem">
						</el-input>
					</el-form-item>
					<el-form-item label="话术类型:">
						<el-select placeholder="请选择" clearable size="mini" v-model="addform.ReplyTypeid">
							<el-option v-for="item in labeloptions" :key="item.dicId" :label="item.dicDesc"
								:value="item.dicId" />
						</el-select>
					</el-form-item>
					<el-form-item label="是否显示:" prop="status">
						<el-radio-group v-model="addform.status">
							<el-radio :label="0">显示</el-radio>
							<el-radio :label="1">不显示</el-radio>
						</el-radio-group>
					</el-form-item>

					<el-form-item label="(选填)回答话术:">
						<el-button type="primary" plain size="mini" @click="addAnswerItem">添加回答话术</el-button>
					</el-form-item>
					<!-- 话术答案列表 -->
					<div class="scroll-view">
						<el-form-item v-for=" (item,index) in addform.answerList" :key="index" :label="'话术'+ index">
							<el-col>
								<el-input size="mini" type="textarea" :rows="3" placeholder="请输入内容"
									v-model="addform.answerList[index].answer">
								</el-input>
								<el-button type="danger" size="mini" icon="el-icon-delete" circle
									style="margin-right:10px" @click="delAnswerItem(index)"></el-button>
							</el-col>
						</el-form-item>
					</div>
				</el-form>
			</template>


			<!-- 修改话术的 -->
			<template v-else>
				<el-form :model="editform" label-position="right" label-width="120px">
					<el-form-item label="问题:">
						<el-input size="mini" :rows="5" placeholder="请输入内容" v-model="editform.problem">
						</el-input>
					</el-form-item>
					<el-form-item label="话术类型:">
						<el-select placeholder="请选择" clearable size="mini" v-model="editform.ReplyTypeid">
							<el-option v-for="item in labeloptions" :key="item.dicId" :label="item.dicDesc"
								:value="item.dicId" />
						</el-select>
					</el-form-item>
					<el-form-item label="是否显示:" prop="status">
						<el-radio-group v-model="editform.status">
							<el-radio :label="0">显示</el-radio>
							<el-radio :label="1">不显示</el-radio>
						</el-radio-group>
					</el-form-item>
				</el-form>
				<div style="text-align:center;color:red">此处并不可以修改答案,若想修改答案请点击"回答话术"<br />查看更多进行修改</div>
			</template>

			<div slot="footer" class="dialog-footer">
				<el-button size="mini" @click="closeUpdate">取 消</el-button>
				<el-button size="mini" type="primary" @click="addScattered()">确 定</el-button>
			</div>
		</el-dialog>

		<!-- 多项答案侧边栏 -->
		<el-drawer size="60%" :with-header="false" :visible.sync="drawer">
			<div class="answer-title">
				<i class="el-icon-question"></i>{{selectproblem.problem}}？
			</div>
			<el-col :span="4" :offset="19">
				<el-button size="mini" type="primary" @click="AnswerAdd(1)" round>添加答案</el-button>
			</el-col>
			<el-col :span="20" :offset="2">
				<el-table :data="selectproblem.answers" :height="tableHeight+200">
					<el-table-column type="index">
					</el-table-column>
					<el-table-column prop="answer" label="回答话术" />
					<el-table-column prop="status" label="显示类型">
						<template slot-scope="scope">
							<el-tag v-if="scope.row.status==0" type="success" size="mini">显示</el-tag>
							<el-tag v-if="scope.row.status==1" type="warning" size="mini">隐藏</el-tag>
						</template>
					</el-table-column>
					<el-table-column label="上传时间">
						<template slot-scope="scope">
							<span>{{scope.row.createTime|formatDate}}</span>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="230px">
						<template slot-scope="scope">
							<el-button type="primary" icon="el-icon-edit" @click="AnswerAdd(2,scope.row,scope.$index)"
								plain></el-button>
							<el-button type="primary" icon="el-icon-delete"
								@click="delAnswer(scope.row.id,scope.$index)" plain></el-button>
						</template>
					</el-table-column>
				</el-table>
			</el-col>
		</el-drawer>
		<!-- 单个答案的操作 -->
		<el-dialog :title="isaddanswer==1?'添加回答':'修改回答'" :visible.sync="dialogVisible2" :before-close="closeUpdate2"
			width="25%">
			<!-- 新增话术的 -->
			<template v-if="isaddanswer==1">
				<el-form :model="addAnswerform" label-position="right" label-width="120px">
					<el-form-item label="问题:">
						<el-input size="mini" disabled :rows="5" placeholder="请输入内容" v-model="selectproblem.problem">
						</el-input>
					</el-form-item>
					<el-form-item label="是否显示:">
						<el-radio-group v-model="addAnswerform.status">
							<el-radio :label="0">显示</el-radio>
							<el-radio :label="1">不显示</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="回答话术:">
						<el-input size="mini" type="textarea" :rows="3" placeholder="请输入内容"
							v-model="addAnswerform.content">
						</el-input>
					</el-form-item>
				</el-form>
			</template>






			<!-- 修改答案的 -->
			<template v-else>
				<el-form :model="editAnswerform" label-position="right" label-width="120px">
					<el-form-item label="问题">
						<el-input size="mini" :rows="5" disabled placeholder="请输入内容" v-model="selectproblem.problem">
						</el-input>
					</el-form-item>
					<el-form-item label="是否显示:" prop="status">
						<el-radio-group v-model="editAnswerform.status">
							<el-radio :label="0">显示</el-radio>
							<el-radio :label="1">不显示</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="回答话术:">
						<el-input size="mini" type="textarea" :rows="3" placeholder="请输入内容"
							v-model="editAnswerform.content">
						</el-input>
					</el-form-item>
				</el-form>
			</template>

			<div slot="footer" class="dialog-footer">
				<el-button size="mini" @click="closeUpdate2">取 消</el-button>
				<el-button size="mini" type="primary" @click="addAnswerScattered()">确 定</el-button>
			</div>
		</el-dialog>
	</el-row>
</template>

<script>
	import {
		getGroupList
	} from '../../../util/index.js'
	import httpClient from '../../../util/request.js';
	var vm;
	export default {
		data() {
			return {
				selectproblem: {}, //选中查看的话术答案
				drawer: false, //更多答案侧边栏
				total: 0,
				pageSizes: [10, 20, 30, 40, 50],
				fileList: [],
				uploadUrl: 'https://qc.xinian727.com/api/source/sysTalkingSkills/upload',
				downloadExcelMode: 'https://img.xinian727.cn/paibo/excel/Words_template.xlsx',
				pageSize: 10,
				pageNum: 1,
				keywords: "",
				scatteredDic: '',
				showStatus: 0,
				tableHeight: window.innerHeight - 300,
				dialogVisible: false,
				dialogVisible2: false,
				scatteredDic: "", //选择的类型
				labeloptions: [],
				tableData: [],
				searchform: {
					datevalue: [],
					keywords: "",
					scatteredDic: '',
					showStatus: ''
				},
				editform: {
					problem: "",
					ReplyTypeid: "",
					status: -1
				},
				editAnswerform: {
					id: "",
					status: -1,
					content: ''
				},
				addform: {
					problem: "",
					ReplyTypeid: "",
					status: -1,
					answerList: []
				},
				addAnswerform: {
					problemId: '',
					content: '',
					status: -1
				},
				isadd: -1,
				isaddanswer: -1,
				editIndex: -1, //当前修改的答案的index
				reviewStatus: [{
						title: '显示',
						type: 0
					},
					{
						title: '隐藏',
						type: 1
					}
				]
			};
		},
		mounted() {
			vm = this
			this.getScatteredDicAll();
			this.getTable()
		},
		filters: { // 使用计算属性
			formatDate(val) {
				return val ? vm.$moment(val).format('YYYY-MM-DD HH:MM:SS') : ''
			}
		},
		methods: {
			//获取数据列表
			getTable() {
				var params = {
					pageSize: this.pageSize,
					pageNum: this.pageNum,
					keywords: this.keywords,
					skillsType: this.scatteredDic,
					status: this.showStatus
				};
				this.$http
					.get(`/api/source/sysTalkingSkills/selectSysTalkingSkills`, {
						params
					})
					.then((res) => {
						if (res.data.status == 0) {
							let list = res.data.data.list
							list.forEach(item => {
								item.defaultAnswer = !item.answers ? '' : item.answers[0].answer.substr(0,
									30) + '...'
							});
							this.tableData = list
							this.total = res.data.data.total
						} else {
							this.$message({
								type: 'error',
								message: '系统繁忙，请稍后再试~~'
							});
						}
					});
			},

			//话术类型
			getScatteredDicAll() {
				getGroupList('话术库', '话术库分类')
					.then(res => {
						this.labeloptions = res
					})
			},

			//添加话术
			WordsAdd(type, val) {
				this.isadd = type
				if (type == 2) {
					this.editform.problem = val.problem
					this.editform.id = val.id
					this.editform.status = val.status
					this.editform.ReplyTypeid = val.type
				}
				this.dialogVisible = true
			},

			//下载模板
			downloadExcel() {
				window.location.href = this.downloadExcelMode
			},

			uploadError(err, file, fileList) {
				this.$message({
					type: 'error',
					message: '文件上传失败,请联系三土或者怀达'
				});
			},

			uploadSuccess(response, file, fileList) {

				if (response) {
					this.$message({
						type: 'success',
						message: '文件上传成功!!'
					});
					this.getTable()
				} else {
					this.$message({
						type: 'error',
						message: '文件上传成功,但小库增加可能失败,请联系怀达'
					});
				}
			},

			//pagesize改变
			handleSizeChange(val) {
				this.pageNum = 1;
				this.pageSize = val;
				this.getTable();
			},

			//页码改变
			handleCurrentChange(val) {
				this.pageNum = val;
				this.getTable();
			},

			//搜索
			search() {
				this.keywords = this.searchform.keywords
				this.scatteredDic = this.searchform.scatteredDic,
					this.showStatus = this.searchform.showStatus
				this.pageNum = 1
				this.getTable()
			},

			//清空
			Empty() {
				this.keywords = this.searchform.keywords = ''
				this.scatteredDic = this.searchform.scatteredDic = '',
					this.searchform.showStatus = ''
				this.pageNum = 1
				this.search()
			},

			//弹框取消
			closeUpdate() {
				this.editform = {
						problem: "",
						ReplyTypeid: "",
						status: -1
					},
					this.addform = {
						problem: "",
						ReplyTypeid: "",
						status: -1,
						answerList: []
					},
					this.dialogVisible = false
			},

			//确定
			addScattered() {
				let _this = this
				//添加
				if (this.isadd == 1) {
					if (!this.addform.problem.trim() || this.addform.status < 0 || !this.addform.ReplyTypeid) {
						return this.$message({
							type: 'error',
							message: '请填写完整话术再提交~~'
						})
					}
					var data = {
						problem: this.addform.problem,
						answers: this.addform.answerList,
						type: this.addform.ReplyTypeid,
						status: this.addform.status
					}

					this.$http
						.post(`/api/source/sysTalkingSkills/insertTalk`, data)
						.then((res) => {
							if (res.data) {
								this.$message({
									type: 'success',
									message: '添加话术成功！！'
								});
								this.getTable()
								_this.closeUpdate()
							} else {
								this.$message({
									type: 'error',
									message: '系统繁忙，请稍后再试~~'
								});
							}
						});
				}
				//修改
				if (this.isadd == 2) {
					var data = {
						problem: this.editform.problem,
						status: this.editform.status,
						type: this.editform.ReplyTypeid,
						id: this.editform.id
					}
					this.$http
						.post(`/api/source/sysTalkingSkills/updateTalk`, data)
						.then((res) => {
							if (res.data) {
								this.$message({
									type: 'success',
									message: '修改话术成功！！'
								});
								_this.closeUpdate()
								this.getTable()
							} else {
								this.$message({
									type: 'error',
									message: '系统繁忙，请稍后再试~~'
								});
							}
						});
				}
			},

			// 删除整条问题及答案
			delScattered(id, status) {
				this.$confirm('此操作将删除该问题及所有答案, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					center: true
				}).then(() => {
					this.$http.post(`/api/source/sysTalkingSkills/deleteTalk?id=${id}`).then(res => {
						if (res.data) {
							this.$message({
								type: 'success',
								message: '移除完成'
							});
							this.getTable()
						} else {
							this.$message({
								type: 'error',
								message: '系统繁忙，请稍后再试~~'
							});
						}
					}).catch(error => {});
				});
			},

			// 点击查看更多答案
			loadMoreAnswer(answerdetail, type) {
				this.selectproblem = answerdetail
				if (type == 1) {
					this.drawer = true
				}
				if (type == 2) {
					this.AnswerAdd(1)
				}
			},

			//添加答案列表
			addAnswerItem() {
				let item = {
					answer: '',
					status: 0,
					isnum: 1
				}
				let list = [...this.addform.answerList]
				list.push(item)
				this.addform.answerList = list
			},

			delAnswerItem(index) {
				let list = [...this.addform.answerList]
				list.splice(index, 1)
				this.addform.answerList = list
			},

			// +++++++++++++++  对问题答案的操作+++++++++
			AnswerAdd(type, val, index) {
				this.isaddanswer = type
				if (type == 2) {
					this.editAnswerform.id = val.id
					this.editAnswerform.status = val.status
					this.editAnswerform.content = val.answer
					this.editIndex = index
				}
				if (type == 1) {
					this.addAnswerform.problemId = this.selectproblem.id
				}
				this.dialogVisible2 = true
			},

			//弹框取消
			closeUpdate2() {
				// 优化
				this.editAnswerform = {
						id: "",
						status: -1,
						content: ''
					},
					this.addAnswerform = {
						problemId: '',
						content: '',
						status: -1
					},
					this.dialogVisible2 = false
			},

			//确定
			addAnswerScattered() {
				var _this = this
				//添加

				if (this.isaddanswer == 1) {
					if (!this.addAnswerform.content.trim() || this.addAnswerform.status < 0) {
						return this.$message({
							type: 'error',
							message: '请填写完整回答话术再提交~~'
						})
					}
					var data = {
						problemId: this.addAnswerform.problemId,
						answer: this.addAnswerform.content,
						status: this.addAnswerform.status,
						isnum: 2
					}

					this.$http
						.post(`/api/source/sysTalkingSkills/insertAnswer`, data)
						.then((res) => {
							if (res.data) {
								this.$message({
									type: 'success',
									message: '添加回答话术成功！！'
								});
								//物理添加
								if (!!_this.selectproblem.answers) {
									let list = [..._this.selectproblem.answers]
									let item = {
										answer: _this.addAnswerform.content,
										createTime: new Date(),
										problemId: _this.addAnswerform.problemId,
										status: _this.addAnswerform.status
									}
									list.push(item)
									_this.selectproblem.answers = list
								}
								_this.getTable()
								_this.closeUpdate2()
								setTimeout(() => {
									_this.drawer = false
								}, 500);
							} else {
								this.$message({
									type: 'error',
									message: '系统繁忙，请稍后再试~~'
								});
							}
						});
				}
				//修改
				if (this.isaddanswer == 2) {
					var data = {
						id: this.editAnswerform.id,
						status: this.editAnswerform.status,
						answer: this.editAnswerform.content,
						isnum: 2
					}
					this.$http
						.post(`/api/source/sysTalkingSkills/updateAnswer`, data)
						.then((res) => {
							if (res.data) {
								this.$message({
									type: 'success',
									message: '修改回答话术成功！！'
								});
								//物理修改
								let list = [..._this.selectproblem.answers]
								let item = {
									...list[_this.editIndex],
									status: _this.editAnswerform.status,
									answer: _this.editAnswerform.content,
								}
								list.splice(_this.editIndex, 1, item)
								_this.selectproblem.answers = list
								this.getTable()
								_this.closeUpdate2()
							} else {
								this.$message({
									type: 'error',
									message: '系统繁忙，请稍后再试~~'
								});
							}
						});
				}

			},

			//删除答案
			delAnswer(id, index) {
				var _this = this
				this.$confirm('此操作将删除该条答案, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					center: true
				}).then(() => {
					this.$http.post(`/api/source/sysTalkingSkills/deleteAnswer?id=${id}`).then(res => {
						if (res.data) {
							this.$message({
								type: 'success',
								message: '移除完成'
							});

							//物理删除
							let list = [..._this.selectproblem.answers]
							list.splice(index, 1)
							_this.selectproblem.answers = list
							_this.getTable()
						} else {
							this.$message({
								type: 'error',
								message: '系统繁忙，请稍后再试~~'
							});
						}
					}).catch(error => {});
				});
			},

			//同步缓存
			SynchronizeData() {
				this.$http.get(`/api/source/sysproblemanswer/asyncProblem`).then(res => {
					if (res.data.status == 0) {
						this.$message({
							type: 'success',
							message: '更新数据成功'
						});
					} else {
						this.$message({
							type: 'error',
							message: '系统繁忙，请稍后再试~~'
						});
					}
				}).catch(error => {});
			}
		},
	};
</script>

<style lang="less" scoped>
	.productAttrAddBox {
		width: 300px;
	}

	/deep/.el-drawer__open .el-drawer.rtl {
		overflow: auto;
	}

	.pagination {
		margin-left: 50%;
		margin-top: 20px;
		z-index: 2;
		transform: translateX(-50%);
	}

	.typeDiv {
		padding: 2px 8px;
		margin: 1px;
		font-size: 12px;
		height: 14px;
		line-height: 14px;
		background: #808080ad;
		color: white;
		border-radius: 11px;

	}

	/deep/.el-drawer {
		overflow: auto;
	}

	/deep/.el-drawer__body {
		overflow: auto;
	}

	/deep/.el-input {
		width: auto;
	}

	/deep/.el-button--mini,
	.el-button--mini.is-round {
		margin-left: 15px;
	}

	/deep/.el-input {
		width: auto;
		height: auto;
	}

	/deep/.el-upload-list {
		height: 0;
		// overflow: hidden;·
	}


	.scroll-view {
		max-height: 260px;
		overflow-y: scroll;
		overflow-x: hidden;
		margin: 10px;
	}

	.scroll-view::-webkit-scrollbar {
		/*滚动条整体样式*/
		width: 4px;
		/*高宽分别对应横竖滚动条的尺寸*/
		height: 1px;
	}

	.scroll-view::-webkit-scrollbar-thumb {
		/*滚动条里面小方块*/
		border-radius: 2px;
		box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background: #66b8ff;
	}

	.scroll-view::-webkit-scrollbar-track {
		/*滚动条里面轨道*/
		box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		border-radius: 2px;
		background: #ededed;
	}

	//自定义小样式
	.answer-title {
		max-width: 100%;
		min-width: 100%;
		padding: 30px;
		text-align: left;
		font-size: 20px;
		font-weight: 900;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	}
</style>
